import React from 'react';
import { motion } from 'framer-motion';
const statsBar = [{
  value: '+700.000',
  label: 'vendedores activos en ML Argentina'
}, {
  value: '68%',
  label: 'no sabe su margen real después de comisiones'
}, {
  value: '$0',
  label: 'control financiero tiene la mayoría de vendedores independientes'
}];
const painPoints = [{
  emoji: '💸',
  title: 'Vendés todos los días pero al fin del mes el dinero no aparece',
  desc: 'Las comisiones, el envío y los impuestos te comen el margen sin que te des cuenta. Seguís trabajando sin saber si ganás.'
}, {
  emoji: '📉',
  title: 'Fijás precios a ojo y no sabés si estás ganando o perdiendo',
  desc: 'Sin una calculadora de rentabilidad real, cada precio que publicás es una apuesta. A veces ganás, a veces perdés.'
}, {
  emoji: '🔴',
  title: 'Te quedás sin stock justo cuando más vendés',
  desc: 'Sin un sistema de alertas, la reposición siempre llega tarde. Perdés ventas y rankings por falta de inventario.'
}, {
  emoji: '📊',
  title: 'Hacés promos sin saber si te convienen',
  desc: 'Mercado Libre te muestra el volumen de ventas, pero no si esa promo te dejó ganancia o pérdida.'
}, {
  emoji: '💱',
  title: 'El dólar sube y tus precios quedan desactualizados',
  desc: 'Compraste stock a un tipo de cambio y vendés a otro. Sin actualizarte, trabajás con margen negativo sin saberlo.'
}, {
  emoji: '📦',
  title: 'No sabés qué productos agregar para ganar más',
  desc: 'Invertís en stock nuevo a intuición y a veces el producto no rota. Necesitás un sistema para evaluar antes de comprar.'
}];
export function ProblemSection() {
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-221">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-222">
            ¿Te identificás con alguna de estas situaciones?
          </h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto" data-id="element-223">
            Esto es lo que vive el 80% de los vendedores activos de ML en
            Argentina
          </p>
        </motion.div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid md:grid-cols-3 gap-4 mb-12" data-id="element-224">
          {statsBar.map(stat => <div key={stat.value} className="bg-white/5 border border-white/5 rounded-xl p-5 text-center" data-id="element-225">
              <div className="text-gold font-display font-bold text-2xl md:text-3xl mb-1" data-id="element-226">
                {stat.value}
              </div>
              <div className="text-white/50 text-sm" data-id="element-227">{stat.label}</div>
            </div>)}
        </motion.div>

        {/* Pain Points Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-228">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-navy-mid/60 border border-white/5 rounded-2xl p-6 hover:border-gold/50 transition-colors duration-300" data-id="element-229">
              <div className="text-3xl mb-3" data-id="element-230">{point.emoji}</div>
              <h3 className="font-display font-bold text-white text-lg mb-2" data-id="element-231">
                {point.title}
              </h3>
              <p className="text-white/45 text-sm leading-relaxed" data-id="element-232">
                {point.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Bottom Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border-2 border-gold/40 rounded-2xl p-6 md:p-8 text-center bg-gold/5" data-id="element-233">
          <p className="text-white text-lg md:text-xl font-semibold leading-relaxed" data-id="element-234">
            Si te identificaste con al menos{' '}
            <span className="text-gold" data-id="element-235">una sola</span> de estas situaciones,{' '}
            <span className="text-gold" data-id="element-236">
              el Kit ML Rentable fue diseñado exactamente para vos.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}